__turbopack_context__.v({
  "className": "cormorant_c350b081-module__kAVkmq__className",
});
